import styled from '@emotion/styled';
import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  shouldForwardProp,
} from '@kizi/core-components';
import CSS from 'csstype';
import React from 'react';
import { color, compose } from 'styled-system';

export interface BasePathProps extends CoreBaseProps, ColorProps {
  fill?: CSS.Property.Fill;
}

export type PathProps = React.PropsWithRef<BasePathProps>;

const get = (obj, path, defaultValue = undefined) => {
  const travel = (regexp) =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce(
        (res, key) => (res !== null && res !== undefined ? res[key] : res),
        obj
      );
  const result = travel(/[,[\].]+/);
  return result === undefined || result === obj ? defaultValue : result;
};

export const Path = styled('path', {
  shouldForwardProp: (prop) =>
    shouldForwardProp<BasePathProps>(prop as keyof BasePathProps),
})<PathProps>(
  defineWithTheme('path'),
  ({ fill, theme }) => {
    return fill
      ? `
    fill: ${get((theme as any).colors, fill)};
  `
      : '';
  },
  compose(color)
);
